// Module
var code = " <a class=\"button accent small radius\" href=\"\" ng-click=needAssistanceCtrl.contactUs()>Need assistance?</a> ";
// Exports
module.exports = code;